export type WalletTransactionKind = 'topup' | 'grant' | 'adjustment' | 'refund';

export class WalletTransaction {
  id!: string;                 // UUID
  kind!: WalletTransactionKind;
  amountCents!: number;        // signed negative = debit
  amount!: string;
  balanceAfterCents!: number;
  currency!: string;
  description: string | null = null;
  createdAt!: string;

  constructor(data: any = {}) {
    this.id = data.id;
    this.kind = data.kind;
    this.amountCents = data.amount_cents;
    this.amount = data.amount;
    this.balanceAfterCents = data.balance_after_cents;
    this.currency = data.currency;
    this.description = data.description ?? null;
    this.createdAt = data.created_at;
  }

  get isCredit(): boolean {
    return this.amountCents >= 0;
  }
}
